export const PROMPT_ASSISTANT_FLOW_ID = import.meta.env.VITE_QUICK_CHAT_FLOW_ID || '';
export const PROMPT_ASSISTANT_INPUT_ID = 'varInputNode_0.4966804413076733';

export interface ConnectedNode {
  label: string;
  type: string;
  targetField?: string;
}

export interface ConnectedNodes {
  incoming: ConnectedNode[];
  outgoing: ConnectedNode[];
}

export interface PromptAssistantProps {
  fieldName: string;
  nodeData: Record<string, unknown>;
  textValue: string;
  flowSummary: string;
  connectedNodes?: ConnectedNodes;
  onOutput: (output: string) => void;
  onVariables?: (variables: string[]) => void;
  sessionId?: string;
}

export interface PromptAssistantMessage {
  role: 'user' | 'assistant';
  content: string;
  timestamp: string;
}
